import { render } from "./Gallery.vue?vue&type=template&id=20eb94bd&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=20eb94bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20eb94bd"]])

export default __exports__